<template>
  <div class="index" @mousedown="close">
    <!-- 轮播 Start -->
    <div class="htmleaf-container">
      <div class="swiper-container container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in banners"
            :key="index"
          >
            <img class="bannerradius" :src="item.coverUrl" />
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播 End -->

    <!--大赛背景 Start-->
    <div class="navbar navbar-expand-lg navbar-dark home-bg2">
      <div class="container" style="padding: 0">
        <page2 />
      </div>
    </div>
    <!-- 大赛背景 End -->
    <!-- 赛事资讯 Start -->
    <div class="navbar navbar-expand-lg navbar-dark backimg">
      <div class="container" style="padding: 0">
        <page3 />
      </div>
    </div>
    <!-- 精彩集锦 End -->
    <!-- 通知 进展 结果 Start -->
    <div class="navbar-expand-lg navbar-dark home-bg4">
      <div class="container" style="padding: 0">
        <page4 />
      </div>
    </div>
    <!-- 通知 进展 结果 End -->
    <!-- 底部 Start -->
    <div class="navbar-expand-lg navbar-dark footerback">
        <Footer />
    </div>
    <!-- 底部 End -->
  </div>
</template>

<script>
import Swiper from 'swiper' // 导入
import QRCode from 'qrcodejs2'
import Page2 from '@/components/home/part2/Part2.vue'
import Page3 from '@/components/home/part3/Part3.vue'
import Page4 from '@/components/home/part4/Part4.vue'
import Footer from '@/components/home/Footer.vue'
export default {
  components: {
    Page2, Page3, Page4, Footer
  },
  data () {
    return {
      images: [],
      weiXin: undefined,
      weiXinOnce: 0,
      activeName: '',
      activeNotice: '',
      name: '',
      phone: '',
      address: '',
      textarea: '',
      banners: [],
      newsSwiper: [
        '.../../static/img/news.png'
      ],

      compotiiton: [],
      announcement: [],
      raceNews: {
        news: [],
        videos: [],
        images: []
      },
      raceNewsItemActive: '',
      hostUnit: [],
      undertakeUnit: [],
      subcontractor: [],
      charitySponsorship: [],
      charitySupport: []
    }
  },
  created () {
    this.$nextTick(function () {
      this.getList()
    })
  },
  methods: {
    onPlayerPlay (player, index) {
      // 解决视频可以多个并行播放的问题，实现唯一视频播放，使用中间变量存放当前播放视频和id，播放其他视频时，暂停当前视频，操作当前视频的播放和暂定
      if (this.currentPlayer) {
        if (this.olayerIndex == index) {
          this.currentPlayer.play()
        } else {
          this.currentPlayer.pause()
        }
      }
      this.currentPlayer = player
      this.olayerIndex = index
    },
    QQShare () {
      var param = {
        url: window.location.href,
        desc: '三星大赛' /* 分享理由 */,
        title: '三星大赛' /* 分享标题(可选) */,
        summary: '三星大赛好' /* 分享描述(可选) */,
        pics:
          'https://bj.bcebos.com/v1/guojidasai/production/643506767768435bbad3a3a95b065cd4.jpg?authorization=bce-auth-v1%2F9b7f9270b2f0455baca5152ed607bb29%2F2020-10-21T06%3A51%3A20Z%2F-1%2F%2Ff3167545feeec68b2e89cb5a51ff24430def9ce658957bc475059324f1f75440' /* 分享图片(可选) */,
        flash: '' /* 视频地址(可选) */,
        site: '' /* 分享来源 (可选) */
      }
      var s = []
      for (var i in param) {
        s.push(i + '=' + encodeURIComponent(param[i] || ''))
      }
      var targetUrl =
        'https://connect.qq.com/widget/shareqq/index.html?' + s.join('&')
      window.open(targetUrl, 'qq')
    },
    WeiBoShare () {
      var param = {
        url: window.location.href,
        type: '3',
        count: '1' /** 是否显示分享数，1显示(可选) */,
        appkey: '' /** 您申请的应用appkey,显示分享来源(可选) */,
        title: '三星大赛' /** 分享的文字内容(可选，默认为所在页面的title) */,
        pic:
          'https://bj.bcebos.com/v1/guojidasai/production/643506767768435bbad3a3a95b065cd4.jpg?authorization=bce-auth-v1%2F9b7f9270b2f0455baca5152ed607bb29%2F2020-10-21T06%3A51%3A20Z%2F-1%2F%2Ff3167545feeec68b2e89cb5a51ff24430def9ce658957bc475059324f1f75440' /** 分享图片的路径(可选) */,
        ralateUid: '' /** 关联用户的UID，分享微博会@该用户(可选) */,
        rnd: new Date().valueOf()
      }
      var temp = []
      for (var p in param) {
        temp.push(p + '=' + encodeURIComponent(param[p] || ''))
      }
      var targetUrl =
        'https://service.weibo.com/share/share.php?' + temp.join('&')
      window.open(targetUrl, 'sinaweibo')
    },
    WeiXinShare () {
      if (!this.weiXin) {
        this.weiXin = window.location.href
      } else {
        this.weiXin = undefined
      }
      if (this.weiXinOnce == 0) {
        let qrcode = new QRCode('qrcode', {
          width: 132,
          height: 132,
          text: this.weiXin // 二维码地址
        })
        this.weiXinOnce = 1
      }
    },
    close () {
      this.weiXin = undefined
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onticeClick (tab, event) {
      console.log(tab, event)
    },
    getList () {
      // banner
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Banner'
      this.axios.get(api, {}).then(response => {
        this.banners = response.data.rows
      })

      // 创新实验暨作品
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Innovative experiments'
      this.axios.get(api, {}).then(response => {
        this.compotiiton = response.data.rows
        this.activeName = this.compotiiton[0].title
      })

      // 赛事资讯
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Event News'
      this.axios.get(api, {}).then(response => {
        this.raceNews.news = response.data.rows
      })
      // 视频中心
      var api =
        this.siteURL +
        '/actuator/article/selectArticleFile?siteId=' +
        this.siteId +
        '&nameEn=Selection results'
      this.axios.get(api, {}).then(response => {
        this.raceNews.videos = response.data.rows
      })
      // 精品图片
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Wonderful moment'
      this.axios.get(api, {}).then(response => {
        this.raceNews.images = response.data.rows
        this.images = []
        this.raceNews.images.forEach(item => this.images.push(item.coverUrl))
      })

      // 通知公告
      // var api = this.siteURL + "/actuator/article/list?channelId=70";
      // this.axios.get(api, {}).then(response => {
      //   this.announcement = response.data.rows;
      //   console.log("通知公告",response.data.rows);
      // });
      /*  var url = this.siteURL + "/actuator/channel/list?siteId=" +this.siteId +"&url=/indexTrends";
      this.axios.get(url, {}).then((response) => {
        this.channelId = response.data.rows[0].id;
        var api =  this.siteURL + "/actuator/article/list?channelId=" + this.channelId;
        this.axios.get(api, {}).then((response) => {
          this.announcement = response.data.rows;
        });
      }); */
      // 赛事资讯
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Trends'
      this.axios.get(api, {}).then(response => {
        this.announcement = response.data.rows
      })

      // 主办单位
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Organizer'
      this.axios.get(api, {}).then(response => {
        this.hostUnit = response.data.rows
      })

      // 承办单位
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Organ'
      this.axios.get(api, {}).then(response => {
        this.undertakeUnit = response.data.rows
      })

      // 分赛区承办
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Organized by sub-region'
      this.axios.get(api, {}).then(response => {
        this.subcontractor = response.data.rows
      })

      // 独家公益赞助
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Exclusive charity sponsorship'
      this.axios.get(api, {}).then(response => {
        this.charitySponsorship = response.data.rows
      })

      // 公益支持单位
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Charity support unit'
      this.axios.get(api, {}).then(response => {
        this.charitySupport = response.data.rows
      })
    },
    getRaceNews (nameEn) {
      this.raceNewsItemActive = nameEn
      // this.raceNews = [];
      // //赛事资讯
      // var api =
      //   this.siteURL + "/actuator/article/listAndFile?channelId=" + channelId;
      // this.axios.get(api, {}).then((response) => {
      //   this.raceNews = response.data.rows;
      //   this.images = [];
      //   this.raceNews.forEach((item) => this.images.push(item.coverUrl));
      // });
    },
    trendsDetail (id) {
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: id }
      })
      window.open(routeUrl.href, '_blank')
    },
    toDetail (e) {
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: e }
      })
      window.open(routeUrl.href, '_blank')
    },
    toImageDetail (e) {
      var api = this.siteURL + '/actuator/file/list?articleId=' + e
      this.axios.get(api, {}).then(response => {
        if (response.data.total > 0) {
          let routeUrl = this.$router.resolve({
            path: '/imageDetail',
            query: { id: e }
          })
          window.open(routeUrl.href, '_blank')
        } else {
          this.$message({
            showClose: true,
            message: '无图集，请点击图片查看大图',
            type: 'error'
          })
        }
      })
    },
    download (coverId) {
      if (coverId === undefined || coverId === null) {
        this.$message('没有文件可下载')
        return
      }
      var api = this.siteURL + '/actuator/storage/' + coverId
      this.axios.get(api, {}).then(response => {
        let fileUrl = response.data.data.fileName
        var downUrl = this.siteURL + '/actuator/storage/download/' + coverId
        this.axios.defaults.headers.post['Content-Type'] =
          'application/x-www-form-urlencoded'
        this.axios({
          method: 'post',
          url: downUrl,
          responseType: 'blob'
        }).then(res => {
          let data = res.data
          if (!data) {
            return
          }
          const blob = new Blob([data])
          // 其他非IE内核支持H5的浏览器
          let url = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileUrl)
          document.body.appendChild(link)
          link.click()
        })
      })
    },
    toMediaCenter (e) {
      let routeUrl = this.$router.resolve({
        path: '/mediaCenter',
        query: { nameEn: e }
      })
      window.open(routeUrl.href, '_blank')
    }
    // 轮播方法
    // myswiper: function() {
    //   var mySwiper = new Swiper(".swiper-container", {
    //     //设置轮播图防线
    //     direction: "horizontal",
    //     // //开启循环模式
    //     loop: true,
    //     //自动轮播
    //     autoplay: true,
    //     // 如果需要分页器
    //     pagination: ".swiper-pagination",
    //     paginationClickable :true,
    //     // 如果需要前进后退按钮
    //     nextButton: ".swiper-button-next",
    //     prevButton: ".swiper-button-prev",

    //   });
    // }
  }
  // mounted() {
  //   this.myswiper();
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.htmleaf-container {
  background-image: url(~@/assets/images/homebg1.png);
}
.home-bg2 {
  background: url(~@/assets/images/homebg2.png);
  background-position: center;
  background-size: 100% 100%;
}
.home-bg4 {
  background: url(~@/assets/images/homebg4.png);
  background-position: center;
  background-size: 100% 100%;
}
.index .el-tabs__content {
  background: #f0f7ff;
  padding: 16px;
  height: 231px;
  position: absolute;
}
.index .el-tabs__item.is-active {
  color: white;
  background: #409eff;
}
.el-row {
  margin-bottom: 20px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.backimg {
  width: 100%;
  background: url(~@/assets/images/homebg3.png);
  background-position: center;
  background-size: 100% 100%;
}
.decoration {
  width: 325px;
  position: relative;
  left: -45px;
  top: 35px;
}
.maxtitle {
  background: white;
  height: 278px;
}
.titlepad {
  padding: 15px;
  text-align: left;
}
.conterpad {
  padding: 15px;
  text-align: left;
  line-height: 26px;
}
.create {
  text-align: left;
  width: 50%;
  float: left;
  padding: 0 15px;
}
.mincreate {
  text-align: left;
  width: 50%;
  float: left;
  padding: 0 15px;
  position: relative;
  top: -15px;
}
.createicon {
  width: 15px;
}
.mintitle {
  background: white;
  height: 100px;
}
.minsize {
  font-size: 12px;
}
.paddheight {
  padding-right: 0px;
}
.index .notice .el-tabs__nav {
  float: right;
}
.index .notice .el-tab-pane {
  width: 1250px;
  height: 350px;
  border: 1px solid #7ea2f3;
  background-color: #f6f9ff;
}

.index .notice .el-tabs--card > .el-tabs__header {
  border-bottom: 0px solid #e4e7ed;
}
.index .notice .el-tabs__item.is-active {
  color: #0c71fd;
  background: #ebf1fd;
  border: 1px solid #1561ef !important;
}
.notice .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px solid #e4e7ed;
}
.notice .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0px solid #e4e7ed;
}
.contestBack .el-tabs--card > .el-tabs__header {
  padding-left: 0px;
  border-bottom: 0px solid #e4e7ed;
}
.contestBack .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px solid #e4e7ed;
}
.contestBack .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0px solid #e4e7ed;
}
.contestBack .el-tabs__item {
  margin-left: 16px;
  border-radius: 5px;
  border: 1px solid #1561ef !important ;
  font-size: 15px;
  color: #0c71fd;
}
.contestBack .el-tabs__item.is-active {
  color: white;
  background: #1561ef;
  border: 1px solid #1561ef !important;
}

.footerback {
  background: #5a5a5a;
  color: #fff;
}
.comments .el-input__inner {
  background-color: #073f8b;
  border-radius: 0px;
  margin: 10px 0;
}
.comments .el-textarea__inner {
  margin: 10px 0px;
  height: 160px;
  resize: none;
  border-radius: 0px;
  background-color: #073f8b;
  border: 1px solid #3677e7;
}
.comments .el-button {
  width: 55px;
  margin: 10px auto;
  line-height: 40px;
  text-align: center;
  padding: 10px;
  height: 160px;
  border-radius: 0px;
  border: 1px solid #3677e7;
  float: left;
}

.raceNewsItem {
  width: 100%;
  height: 82px;
  line-height: 80px;
  background: #fff;
  border: 1px solid #1a78fc;
  border-radius: 5px;
  color: #1a78fc;
  margin-top: 10px;
  position: relative;
  cursor: pointer;
  text-align: center;
}

.raceNewsItem_active {
  background: #1a78fc;
  color: #fff;
}

.direction {
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 15px solid #1a78fc;
  position: absolute;
  top: 28px;
  right: -15px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.footerTop {
  width: 90%;
  background: #0954bb;
  border-radius: 10px;
  position: absolute;
  top: -90px;
  left: 5%;
  padding: 30px;
}

.footerBottom {
  /* height: 500px; */
  margin-top: 130px;
  padding-bottom: 20px;
}

.footerTitle {
  width: 120px;
  border-bottom: 1px solid #6d6d6d;
  font-size: 18px;
  line-height: 80px;
}
</style>

<style scoped>
.index .el-tabs__item {
  padding-right: 18px;
  width: 126px;
  text-align: center;
}

.index
  .el-tabs--top.el-tabs--card
  > .el-tabs__header
  .el-tabs__item:nth-child(2) {
  padding-left: 18px;
}

.index .el-carousel__item:nth-child(2n) {
  background-color: #f6f9ff;
  border: 1px solid #7ba0f3;
}

.index .el-carousel__item:nth-child(2n + 1) {
  background-color: #f6f9ff;
  border: 1px solid #7ba0f3;
}

.announcementContent p {
  margin: 0;
  font-size: 14px;
  color: #717275;
  line-height: 30px;
}

.index .el-tab-pane {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  font-size: 1.5em;
}
.vjs-custom-skin > .video-js .vjs-control-bar {
  font-size: 8px !important;
}
.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.6em;
}
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.6em;
  right: -0.5em;
}
.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 1.9;
}
.marginVideo {
  margin: 0 30px;
}
.swiper-container {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue